import cn from 'classnames';
import React from 'react';
import * as styles from './index.module.css';

type DialogContentArgs = {
  hasPaddings?: boolean;
  noDrag?: boolean;
};

export type DialogContentProps = React.PropsWithChildren<DialogContentArgs>;
export function Content({ children, hasPaddings = true, noDrag = false }: DialogContentProps) {
  return (
    <div className={styles.modalContentClip}>
      <div className={styles.modalContentWrapper} {...(noDrag ? { 'data-vaul-no-drag': '' } : {})}>
        <div className={cn(hasPaddings && styles.modalContent)}>{children}</div>
      </div>
    </div>
  );
}
